import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getScoreRange } from '../Score/utils'
import Score from '../Score'
import styles from './styles.module.css'
import messages from './messages'
import { SIZE_BIG } from '../Score/constants'
import cn from 'classnames'
import RatingReviewsCount from '../RatingReviewsCount'

interface IRatingContentProps {
  score: number
  count: number
}

const RatingContent = ({ score, count }: IRatingContentProps) => {
  const category = getScoreRange(score)

  return (
    <div className={cn(styles.ratingContent)}>
      <Score value={score} size={SIZE_BIG} asymetricRoundedShape />

      <div className={styles.label}>
        <span
          className={styles.category}
          style={{ '--categoryColor': category.color } as React.CSSProperties}
        >
          <span className={styles.categoryLabel}>
            <FormattedMessage {...messages[`score${category.level}`]} />
          </span>

          <RatingReviewsCount count={count} />
        </span>
      </div>
    </div>
  )
}

export default RatingContent
